import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../UserContext";
import { FiCheckCircle } from "react-icons/fi";
import { MdOutlineEventAvailable } from "react-icons/md";
// import { FaUserCircle } from "react-icons/fa";

const Profile = () => {
  const { user } = useContext(UserContext);
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user?.user_id) {
      fetch(`http://127.0.0.1:8000/users/${user.user_id}/allsessions`)
        .then((response) => response.json())
        .then((data) => {
          setSessions(data);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching sessions:", error);
          setLoading(false);
        });
    }
  }, [user?.user_id]);

  if (!user) return <div className="text-center p-8">Loading profile...</div>;

  const initials = `${user.firstName?.[0] || ""}${
    user.lastName?.[0] || ""
  }`.toUpperCase();

  return (
    <div className="container mx-auto bg-gray-50 flex justify-center font-serif">
      <div className="w-full bg-white rounded-xl p-10">
        {/* Header */}
        <div className="flex items-center space-x-6 border-b pb-6">
          <div className="w-24 h-24 bg-cyan-600 text-white flex items-center justify-center rounded-full text-4xl font-bold overflow-hidden">
            {!user.profilePicture ? (
              <span className="text-3xl font-bold text-white">{initials}</span>
            ) : (
              <img
                src={user.profilePicture}
                alt="Profile"
                className="w-full h-full rounded-full object-cover"
              />
            )}
          </div>

          <div>
            <h2 className="text-3xl font-semibold text-gray-800">
              {user.firstName} {user.lastName}
            </h2>
            <p className="text-gray-500 text-lg">{user.email}</p>
            <p className="flex items-center text-green-600 font-medium mt-2">
              <FiCheckCircle className="mr-1" /> Verified Account
            </p>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-6 mt-6">
          <div className="bg-gray-100 p-3 rounded-lg text-center">
            <p className="text-gray-500">Role</p>
            <p className="text-gray-800 font-medium text-lg">
              {user.role === "fe42ee60-9133-4f0e-b543-740d8697c23b"
                ? "Admin"
                : "User"}
            </p>
          </div>
          <div className="bg-gray-100 p-3 rounded-lg text-center">
            <p className="text-gray-500">Sessions</p>
            <p className="text-gray-800 font-medium text-lg">
              {loading ? "Loading..." : sessions.length}
            </p>
          </div>
          <div className="bg-gray-100 p-3 rounded-lg text-center">
            <p className="text-gray-500">Status</p>
            <p className="text-green-600 font-semibold text-lg">Active</p>
          </div>
        </div>

        {/* Session Overview */}
        <div className="mt-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-4">
            Recent Sessions
          </h3>
          <div className="bg-gray-50 p-6 rounded-lg shadow-md">
            {loading ? (
              <p className="text-gray-500">Loading sessions...</p>
            ) : sessions.length === 0 ? (
              <p className="text-gray-500">No sessions available</p>
            ) : (
              <ul className="divide-y divide-gray-200">
                {sessions.slice(0, 5).map((session, index) => (
                  <li
                    key={index}
                    className="py-3 flex justify-between items-center"
                  >
                    <div className="flex items-center space-x-4">
                      <MdOutlineEventAvailable className="text-cyan-600 text-2xl" />
                      <div>
                        <p className="text-gray-800 font-medium text-lg">
                          {session.coach_name}
                        </p>
                        <p className="text-gray-500 text-sm">
                          {session.created_at
                            ? new Date(session.created_at).toLocaleDateString()
                            : "Date Unavailable"}
                        </p>
                      </div>
                    </div>
                    <span className="text-sm shadow-xl bg-cyan-500 text-white px-3 py-1 rounded-full">
                      Completed
                    </span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
